<template>
  <div
    class="d-mobile-card"
    :class="{ 'shown': isDisplayed }"
    @click="close()"
  >
    <div
      ref="cardContainer"
      class="card-container"
    >
      <div
        class="card-content"
        @click.stop
      >
        <div
          v-if="$slots['card-header']"
          class="card-header grid-flex grid-middle grid-no-response"
        >
          <div class="grid-item">
            <slot name="card-header" />
          </div>
          <div class="grid-item-shrink">
            <button
              class="button-md button-icon button-close"
              @click.stop.prevent="close()"
            />
          </div>
        </div>

        <div class="card-body">
          <slot name="card-body" />
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import mobileMixin from '@d-mixins/mobile';

export default {
  props: {
    storeCloseAction: {
      type: String,
      required: true,
    },
    storeDisplayKey: {
      type: String,
      required: true,
    },
  },
  computed: {
    isDisplayed() {
      return this.$store.getters[this.storeDisplayKey];
    },
  },
  beforeDestroy() {
    this.close();
    this.$el.remove();
  },
  mounted() {
    document.body.appendChild(this.$el);
  },
  methods: {
    close() {
      this.$refs.cardContainer.scrollTop = 0;
      this.$store.dispatch(this.storeCloseAction);
    },
  },
};
</script>

<style lang="scss">
@import "@dui-styles/base";

.d-mobile-card {
  height: 100vh;
  left: 0;
  pointer-events: none;
  position: fixed;
  top: 0;
  width: 100%;
  z-index: $z-index-sticky-actions;

  &:before,
  &:after {
    content: " ";
    left: 0;
    opacity: 0;
    position: fixed;
    width: 100%;
  }

  &:before {
    background-color: $color-translucent-black-dark;
    height: 100vh;

    @include transition((
      opacity
    ));
  }

  &:after {
    background-image: linear-gradient(to bottom, $color-transparent-white, getColor($white) $_5em);
    bottom: 0;
    height: $_6em;
    pointer-events: none;
    z-index: 2;
  }

  &.shown {
    pointer-events: all;

    &:before,
    &:after {
      opacity: 1;
    }

    .card-container {
      bottom: 0;
    }
  }

  .card-container {
    bottom: -100vh;
    height: 100vh;
    left: 0;
    overflow: auto;
    position: fixed;
    transform: translate3d(0,0,0);
    width: 100%;
    -webkit-overflow-scrolling: touch;
    z-index: 1;

    @include transition((
      bottom
    ));
  }

  .card-content {
    background-color: getColor($white);
    border-top-left-radius: $border-radius-lg;
    border-top-right-radius: $border-radius-lg;
    box-sizing: border-box;
    color: getColor($black);
    margin-top: 30vh;
    min-height: 70vh;
    padding: $_2em $_2em $_6em;
    position: relative;
    width: 100%;

    @include screenMoreThan(sm) {
      margin-top: 50vh;
      min-height: 50vh;
    }
  }

  .card-header {
    border-bottom: $border-width-base solid $color-translucent-black;
    padding-bottom: $_1em;
  }

  .menu-open-options {
    display: flex;
    flex-direction: column;
    margin: 0;
    padding: 0;

    li {
      border-top: $border-width-base solid $color-translucent-black;
      display: flex;
      padding: 0;

      &:first-child {
        border-top: none;
      }

      a {
        color: getColor($black);
        flex: 1;
        padding: $_1-5em 0;

        &[disabled] {
          opacity: $disabled-opacity;
          pointer-events: none;
        }

        &.active {
          color: getColor($yellow);

          .dui-icon {
            #icon-fill {
              fill: getColor($yellow);
            }
            #icon-stroke {
              stroke: getColor($yellow);
            }
          }
        }

        .dui-icon {
          margin-right: $_1em;
        }
      }
    }
  }

  .d-reminders-and-notifications-panel {
    margin: (-$_1em) (-$_2em) 0;

    .group-title,
    .d-notification-entry {
      padding-left: $_2em;
      padding-right: $_2em;
    }
  }
}
</style>
